import { debounce } from "lodash";
import * as React from "react";
import { Offer, Savings, SoderbergPartnersClient } from "../api/ApiClient";
import { CopyOverride } from "../api/Config";
import SavingsDescriptionModal from "./SavingsDescriptionModal";
declare global {
  interface Window {
    ClientCopyOverride: CopyOverride;
  }
}

interface Props {
  onChangeConsumption?(consumption: number): void;
  offer: Offer;
}

interface State {
  consumption: number;
  savings?: Savings;
  calculating: boolean;
}

export default class SavingsCalculator extends React.Component<Props, State> {
  private savingsClient: SoderbergPartnersClient =
    new SoderbergPartnersClient();

  constructor(props: Props) {
    super(props);

    this.getSavings = debounce(this.getSavings, 200);

    this.state = {
      consumption: this.props.offer.consumption,
      calculating: false,
    };
  }

  componentDidMount() {
    this.getSavings(this.state.consumption);
  }

  render() {
    return (
      <div className="price-calculator">
        <div className="form-group">
          <label className="control-label mt-2">
            Besparing och årsförbrukning
          </label>
          <div className="input-group">
            <input
              value={this.state.consumption}
              name="consumtion"
              type="number"
              step={100}
              min={0}
              max={50000}
              className="form-control"
              onChange={this.updateConsumption}
            />
            <div className="input-group-append">
              <span className="input-group-text">kWh</span>
            </div>
          </div>
        </div>
        <div
          className={
            "textField color-transition" +
            (this.state.calculating ? " color-lightgrey" : "")
          }>
          Du sparar {this.state.savings?.averageSaving} kr/år
        </div>
        <div className="row">
          <div className="col text-center mb-2">
            <a href="#prisModal" data-toggle="modal">
              Så här räknar vi
            </a>
          </div>
        </div>
        <SavingsDescriptionModal
          savings={this.state.savings}
          offer={this.props.offer}
          consumption={this.state.consumption}
        />
      </div>
    );
  }

  updateConsumption = (event: React.ChangeEvent<HTMLInputElement>): void => {
    this.onChangeConsumption(parseInt(event.target.value));
  };

  onChangeConsumption = (consumption: number): void => {
    this.setState({
      consumption,
    });

    this.props.onChangeConsumption &&
      this.props.onChangeConsumption(consumption);
    this.getSavings(consumption);
  };

  getSavings = async (consumption: number): Promise<void> => {
    this.setState({ calculating: true });
    try {
      let savings = await this.savingsClient.estimatedSavings(
        this.props.offer.id,
        consumption
      );
      this.setState({ savings, calculating: false });
      console.debug("Got estimate savings", savings);
    } catch (error) {
      console.error("Failed to estimate savings", error);
      this.setState({ savings: null, calculating: false });
    }
  };
}
